<!--
<template>
  <el-pagination
          :currentPage="pagination.currentPage"
          :page-size="pagination.pageSize"
          :total="pagination.total"
          :default-page-size="defaultPageSize"
          :page-sizes="pageSizes"
          background
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
  />
</template>

&lt;!&ndash; 使用方法

&ndash;&gt;

<script>

  import {ref, reactive, onMounted} from 'vue';

  export default {
    name: "Pagination",
    props:{
      defaultPageSize:{
        type: Number,
        default: 20,
      },
      pageSizes:{
        type: Array,
        default: [10, 20, 50, 100, 200, 500],
      },
    },
    emits: ['pagingChange'],  //分页改变事件的两个参数: 页面容量 当前页码
    setup(props, context){

      //分页数据
      let pagination = reactive({
        currentPage: 1,
        pageSize: 20,
        total: 0,
      })



      // 页面尺寸改变
      function handleSizeChange(newSize) {
        pagination.pageSize = newSize;
        context.emits('pagingChange', newSize, pagination.currentPage);
      }
      // 页码变化
      function handleCurrentChange(newPage) {
        pagination.currentPage = newPage;
        context.emits('pagingChange', pagination.pageSize, newPage)
      }


      return{ pagination,
        handleSizeChange, handleCurrentChange
      }
    }
  }
</script>

<style scoped>

</style>-->


<template>
  <el-pagination
          background
          :currentPage="pagination.currentPage"
          :page-size="pagination.pageSize"
          :total="pagination.total"
          :page-sizes="pageSizes"
          :layout="layout"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
  />

</template>

<!-- 使用方法 设置个ref = "paging"
  属性:
    currentPage -- 当前页码       默认 1
    pageSize    -- 当前页面容量   默认 20
    total       -- 总内容数       默认 0
    pageSizes   -- 页面容量取值   默认 [10, 20, 50, 100, 200, 500]
    layout      -- 分页显示的内容 默认 "total, sizes, prev, pager, next, jumper"

  事件:
    pagingChange(页面容量, 页码)

  注意: 如果想显示 total 值, 首先获得内容总数量,再使用 instance.$ctx.paging.pagination.total = ***
-->

<script>

  import {ref, reactive, onMounted, } from 'vue';

  export default {
    name: "Pagination",
    props:{
      currentPage:{
        type: Number,
        default: 1
      },
      pageSize:{
        type: Number,
        default: 20
      },
      /*total:{
        type: Number,
        default: 0
      },*/
      total: Number,
      pageSizes:{
        type: Array,
        default: [10, 20, 50, 100, 200, 500],
      },
      layout:{
        type: String,
        default: "total, sizes, prev, pager, next, jumper"
      }
    },
    emits: ['pagingChange'],  //分页改变事件的两个参数: 页面容量 当前页码
    setup(props, context){

      //分页数据
      let pagination = reactive({
        currentPage: props.currentPage,
        pageSize: props.pageSize,
        total: props.total,
      })


      //console.log('pagination.total:',pagination.total)
      /*
      * console.log('props.total:', props.total) 这里等于零 我没搞懂
      * props.total 不好用 why
      * */


      // 页面尺寸改变
      function handleSizeChange(newSize) {
        pagination.pageSize = newSize;
        context.emit('pagingChange', newSize, pagination.currentPage);
      }
      // 页码变化
      function handleCurrentChange(newPage) {
        pagination.currentPage = newPage;
        context.emit('pagingChange', pagination.pageSize, newPage)
      }


      return{ pagination,
        handleSizeChange, handleCurrentChange
      }
    }
  }
</script>

<style scoped lang="less">

</style>